import { render } from "./OrderSelectionComponent.vue?vue&type=template&id=5031f586&scoped=true"
import script from "./OrderSelectionComponent.vue?vue&type=script&lang=js"
export * from "./OrderSelectionComponent.vue?vue&type=script&lang=js"

import "./OrderSelectionComponent.vue?vue&type=style&index=0&id=5031f586&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5031f586"]])

export default __exports__